import React from 'react';
import './NavBar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <nav className='navbar'>
            <ul className='nav-links'>
                <Link to="/" className='nav-link'>Home</Link>
                
                <Link to="/privacy-policy" className='nav-link'>Privacy Policy</Link>
                <Link to="/data-privacy" className='nav-link'>Data Privacy</Link>
                <Link to="/contact" className='nav-link'>Contact</Link>
                
                
                
            </ul>
        </nav>
    );
};

export default Navbar;